import { render, staticRenderFns } from "./OffersTabs.vue?vue&type=template&id=d874b926&scoped=true"
import script from "./OffersTabs.vue?vue&type=script&lang=js"
export * from "./OffersTabs.vue?vue&type=script&lang=js"
import style0 from "./OffersTabs.vue?vue&type=style&index=0&id=d874b926&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d874b926",
  null
  
)

export default component.exports